'use strict';

var exports = $.extend({}, require('base/login/login'));
var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');
var recaptcha = require('../components/recaptcha');
module.exports = {
  login: function login() {
    $('form.login').submit(function (e) {
      var form = $(this);
      e.preventDefault();
      var url = form.attr('action');
      form.spinner().start();
      $('form.login').trigger('login:submit', e);
      recaptcha.check(e, {
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function success(data) {
          // WORKWEAR MODIFICATION - Move logic to hide spinner to error step
          // form.spinner().stop();
          if (!data.success) {
            formValidation(form, data);
            form.spinner().stop();
            $('form.login').trigger('login:error', data);
          } else {
            $('form.login').trigger('login:success', data);
            location.href = data.redirectUrl;
          }
        },
        error: function error(data) {
          if (data.responseJSON.redirectUrl) {
            window.location.href = data.responseJSON.redirectUrl;
          } else {
            $('form.login').trigger('login:error', data);
            form.spinner().stop();
          }
        }
      });
      return false;
    });
  },
  register: function register() {
    $('form.registration').submit(function (e) {
      var form = $(this);
      e.preventDefault();
      var url = form.attr('action');
      form.spinner().start();
      $('form.registration').trigger('login:register', e);
      recaptcha.check(e, {
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function success(data) {
          // WORKWEAR MODIFICATION - Move logic to hide spinner to error step
          // form.spinner().stop();
          if (!data.success) {
            form.spinner().stop();
            $('form.registration').trigger('login:register:error', data);
            formValidation(form, data);
          } else {
            $('form.registration').trigger('login:register:success', data);
            location.href = data.redirectUrl;
          }
        },
        error: function error(err) {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          } else {
            createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
          }
          form.spinner().stop();
        }
      });
      return false;
    });
  },
  resetPassword: function resetPassword() {
    $('.reset-password-form').submit(function (e) {
      var form = $(this);
      e.preventDefault();
      var url = form.attr('action');
      form.spinner().start();
      $('.reset-password-form').trigger('login:register', e);
      recaptcha.check(e, {
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function success(data) {
          form.spinner().stop();
          if (!data.success) {
            formValidation(form, data);
          } else {
            $('.request-password-title').text(data.receivedMsgHeading);
            $('.request-password-body').empty().append('<p>' + data.receivedMsgBody + '</p>');
            if (!data.mobile) {
              $('#submitEmailButton').text(data.buttonText).attr('data-dismiss', 'modal');
            } else {
              $('.send-email-btn').empty().html('<a href="' + data.returnUrl + '" class="btn btn-primary btn-block">' + data.buttonText + '</a>');
            }
          }
        },
        error: function error(err) {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          }
          form.spinner().stop();
        }
      });
      return false;
    });
  }
};